import Modal from '../../Modal/Modal';
import { ChooseLoginModalProps } from './ChooseLoginModal.types';
import ChooseLoginModalForm from './ChooseLoginModalForm/ChooseLoginModalForm';

export default ({ ...props }: ChooseLoginModalProps) => {
  return (
    <Modal style={{ alignItems: 'unset' }} {...props}>
      <h2
        style={{
          fontFamily: 'Quicksand-Bold',
          marginLeft: 'var(--spacing-m)',
          marginRight: 'var(--spacing-m)',
        }}>
        Je souhaite <span className="text-primary">me connecter</span> en tant que...
      </h2>
      <ChooseLoginModalForm />
    </Modal>
  );
};
